import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { partners1, partners10, partners11, partners12, partners13, partners14, partners15, partners16, partners17, partners18, partners19, partners2, partners20, partners21, partners22, partners3, partners4, partners5, partners6, partners7, partners8, partners9, rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import axios from 'axios';


const PartnersItems = () => {


      const { t } = useTranslation();
        const [partners, setPartners] = useState([])

       useEffect(() => {
                      getProducts();
                    }, []);
                  
                    const getProducts = async () => {
                      try {
                        const response = await axios.get(
                          `https://cortex-site.runasp.net/api/Partners`,
                          { withCredentials: false }
                        );
                        console.log(response.data);
                        setPartners(response.data);
                      } catch (error) {
                        console.error("Error fetching products:", error);
                      }
                    };

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#F9F9F9]'>
  <div className='max-w-containerSm md:max-w-container mx-auto flex flex-wrap gap-5'>
    {partners.map((item) => (
      <div className='md:w-[160px] w-[110px] flex items-center'>
        <img src={`https://cortex-site.runasp.net/${item.image}`} className='w-full' alt='' />
      </div>
    ))}
  </div> 
</div>

  )
}

export default PartnersItems